import { render, staticRenderFns } from "./SponsorshipListItem.vue?vue&type=template&id=31149d91&"
import script from "./SponsorshipListItem.vue?vue&type=script&lang=js&"
export * from "./SponsorshipListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports